import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { i18n } from "../../translate/i18n";

const GROUP_ORDER = ["system", "contact", "cliente", "clienteCustom"];

const VariableMenu = ({ catalog, onInsert, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSelect = (variable) => {
    setAnchorEl(null);
    onInsert(variable);
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        startIcon={<AddCircleOutlineIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={disabled}
      >
        {i18n.t("documentTemplates.buttons.insertVariable")}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ style: { maxHeight: 420 } }}
      >
        {GROUP_ORDER.flatMap((group) => {
          const items = (catalog && catalog[group]) || [];
          if (items.length === 0) return [];
          return [
            <ListSubheader key={`header-${group}`} disableSticky>
              {i18n.t(`documentTemplates.editor.variableGroups.${group}`)}
            </ListSubheader>,
            ...items.map((variable) => (
              <MenuItem
                key={variable.key}
                dense
                onClick={() => handleSelect(variable)}
              >
                {variable.label}
              </MenuItem>
            )),
          ];
        })}
      </Menu>
    </>
  );
};

export default VariableMenu;
